import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import LoadingOverlay from '../../common-components/LoadingOverlay';

import EmptyRowsMessage from '../../common-components/EmptyRowsMessage';

import * as stationsReducer from '../reducer';
import * as userStationsReducers from '../../system/reducer/UserStationsReducers';
import * as stationsSearchFormReducer from '../reducer/stationsSearchForm';
import * as stationScreenReducer from '../reducer/stationScreen';
import * as systemReducer from '../../system/reducer';

import * as stationsAction from '../action-mgr';

import * as strings from '../../helpers/strings';
// importing Css
import '../../index.css';

class StationsTable extends Component {

  constructor() {
    super();

    this.handleRowSelect = this.handleRowSelect.bind(this);
  }

  handleRowSelect = (station, index) => e => {
    const { history, selectStation, multiSelect = false, selectedStations, removeStationFromSelections } = this.props;
    if (multiSelect && selectedStations.filter(ss => ss.id === station.id).length) {
      return removeStationFromSelections(selectedStations.findIndex(stn => stn.name === station.name));
    }

    selectStation(station, multiSelect);
    if (!multiSelect)
      history.push("/stations/" + btoa(station.id));
  }

  render() {

    const { totalRecord, stations, subClientStations, loggedInUser, selectedStations, multiSelect = false, closeSnackBar, openedSnackBar, snackBarMessage, isSearching} = this.props;

    var stnList = [];
    if (loggedInUser.role === "admin") {
      stnList = stations
    } else {
      stations.forEach(stns => {
        let filterStn = subClientStations.filter(subStn => subStn.id === stns.id)
        if (filterStn.length > 0) {
          stnList.push(stns)
        }
      })
    }

    var stationList;
    if (multiSelect) {
      stationList = stnList.map(station => {
        return {
          ...station,
          selected: selectedStations.filter(ss => ss.id === station.id).length > 0
        }
      });
    } else {
      stationList = stnList;
    }

    stationList = stnList.sort((a, b) => (a.name > b.name) ? 1 : -1)

    return (
      <Paper >
        {(isSearching) && <LoadingOverlay />}
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          open={openedSnackBar}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{snackBarMessage}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={closeSnackBar}
            >
              <CloseIcon />
            </IconButton>
          ]}
        />
        <Table className="stationInfoTable">
          <TableHead>
            <TableRow>
              {multiSelect && <TableCell width={50} style={{ textAlign: "center" }}>#</TableCell>}
              <TableCell width={100}>{strings.lblName}</TableCell>
              <TableCell width={280}>{strings.lblDescription}</TableCell>
              <TableCell width={280}>{strings.lblProjectName}</TableCell>
              <TableCell width={150}>{strings.lblCountry}</TableCell>
              <TableCell width={150}>{strings.lblCity}</TableCell>
              <TableCell>{strings.lblLocation}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stationList.map((station, index) => {
              return (

                <TableRow key={station.id} hover onClick={this.handleRowSelect(station, index)} style={{ cursor: 'pointer' }}>
                  {multiSelect && <TableCell><Checkbox color={strings.colorPrimary} checked={(selectedStations.some(stn => stn.name === station.name)) ? true : false} /></TableCell>}
                  <TableCell>{station.name}</TableCell>
                  <TableCell>{station.description}</TableCell>
                  <TableCell>{station.projectName}</TableCell>
                  <TableCell>{station.country}</TableCell>
                  <TableCell>{station.city}</TableCell>
                  <TableCell>{station.location}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {!totalRecord && <EmptyRowsMessage message={strings.msgNoStationIsCreated} />}
      </Paper>
    );
  }
}

const mapStateToProps = state => ({
  stations: stationsReducer.getStations(state),
  selectedStations: stationsReducer.getSelectedStations(state),
  isSearching: stationsReducer.getIsSearching(state),
  totalRecord: stationsSearchFormReducer.getPagination(state).totalRecord,
  openedSnackBar: stationScreenReducer.getOpenedSnackBar(state),
  snackBarMessage: stationScreenReducer.getSnackBarMessage(state),
  subClientStations: userStationsReducers.getStations(state),
  loggedInUser: systemReducer.getLoggedInUser(state)
});

const mapActionsToProps = {
  search: stationsAction.search,
  selectStation: stationsAction.selectStation,
  removeStationFromSelections: stationsAction.removeStationFromSelections
};

export default connect(mapStateToProps, mapActionsToProps)(
  withRouter(StationsTable)
)